import { MapPin, Clock, MessageCircle, Mail } from "lucide-react";
import { SEO } from "@/lib/seo";
import { waLink, DEFAULT_WA_MESSAGE } from "@/lib/whatsapp";
import { Reveal } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";

const INFO = [
  { icon: MapPin, title: "Ubicación", text: "Medellín y Valle de Aburrá, Colombia" },
  { icon: Clock, title: "Horario", text: "Lunes a Sábado · 7:00 am - 6:00 pm" },
  { icon: Mail, title: "Correo", text: "hola@colorslimpieza.co" },
];

const ContactPage = () => (
  <div data-testid="contact-page">
    <SEO
      title="Contacto | Colors Limpieza Medellín"
      description="Contáctanos para cotizar la limpieza de muebles, colchones o vehículos en Medellín. Respuesta en minutos por WhatsApp."
    />

    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-widest text-brand">Contacto</p>
          <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Hablemos de tu <span className="text-brand">próxima limpieza</span>
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
            Escríbenos por el canal que prefieras. Respondemos en menos de 15 minutos en horario de atención.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-10 lg:grid-cols-5">
          <div className="space-y-5 lg:col-span-2">
            {INFO.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.08}>
                <div className="flex items-start gap-4 rounded-3xl bg-slate-50 p-6" data-testid={`contact-info-${item.title}`}>
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand-light">
                    <item.icon size={20} className="text-brand-dark" />
                  </div>
                  <div>
                    <h3 className="font-display text-sm font-bold text-slate-900">{item.title}</h3>
                    <p className="mt-1 text-sm text-slate-600">{item.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <a
                href={waLink(DEFAULT_WA_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 rounded-3xl bg-[#25D366] p-6 text-white transition-colors hover:bg-[#1EBE5A]"
                data-testid="contact-whatsapp-card"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/20">
                  <MessageCircle size={20} />
                </div>
                <div>
                  <h3 className="font-display text-sm font-bold">WhatsApp directo</h3>
                  <p className="mt-1 text-sm text-white/90">+57 300 123 4567 · Respuesta inmediata</p>
                </div>
              </a>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="lg:col-span-3">
            <ContactForm />
          </Reveal>
        </div>
      </div>
    </section>
  </div>
);

export default ContactPage;
